import { useMutation } from "@tanstack/react-query"
import { makeDownloadDocument } from "../../domain/use-cases/download-document"
import { httpDocumentRepository } from "../../data/repositories/document-repository"

const downloadDocument = makeDownloadDocument(httpDocumentRepository)

const saveBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

type Params = { docId: string; filename: string }

export const useDownloadDocument = () =>
  useMutation({
    mutationFn: async ({ docId, filename }: Params) => {
      const blob = await downloadDocument(docId)
      saveBlob(blob, filename)
    },
  })
